module.exports = __webpack_public_path__ + "img/smart-construction-section-2-phone1.8fc397f0.png";